function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Cookies from 'js-cookie';
import { config, PlatformName, logEvent } from '@cbhq/client-analytics';

// We should fix this in future to use the CookieProvider
// eslint-disable-next-line no-restricted-imports

// Allow to optionally use sessionStorage while ignoring all errors
// such as calling it server-side, private browser modes, missing
// space on devices, etc.
const generateStorageMethods = method => ({
  getItem: key => {
    try {
      return window[method].getItem(key);
    } catch (e) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      return window[method].setItem(key, value);
    } catch (e) {
      // Ignore
    }
  },
  removeItem: key => {
    try {
      return window[method].removeItem(key);
    } catch (e) {
      // Ignore
    }
  }
});
const sessionStorage = generateStorageMethods('sessionStorage');

/**
 * Returns the unauthenticated Device ID, which is set when the user makes a first
 * request to the monorail, and preserved in a cookie.  This is used as a unique
 * device identifier, for example, in amplitude.
 */

function getDeviceId() {
  return Cookies.get('coinbase_device_id');
}

/*
  Ensures that components using @cbhq/client-analytics's logEvent method does not cause
   errors when done so in non-React based apps.
 */
const globalNavLogEvent = (event, eventData, eventImportance) => {
  if (config.platform !== PlatformName.unknown) {
    return logEvent(event, _objectSpread(_objectSpread({}, eventData), {}, {
      deviceId: getDeviceId() || sessionStorage.getItem('session_coinbase_device_id')
    }), eventImportance);
  }
  return;
};
export { globalNavLogEvent as default };
//# sourceMappingURL=globalNavLogEvent.js.map
